"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Colmn = void 0;
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var NewsList_1 = require("./custom/NewsList");
var SalesOffices_1 = require("./custom/SalesOffices");
var Colmn = function (_a) {
    var columnData = _a.columnData, children = _a.children;
    switch (columnData.type) {
        case "news_list":
            return (react_2.default.createElement(react_1.Box, { className: "row col-md-" + columnData.grid_pc + " col-" + columnData.grid_sp + " " + (columnData.class || ""), css: columnData.class },
                react_2.default.createElement(NewsList_1.NewsList, null)));
        case "sales-offices":
            return (react_2.default.createElement(react_1.Box, { className: "row col-md-" + columnData.grid_pc + " col-" + columnData.grid_sp + " " + (columnData.class || ""), css: columnData.class },
                react_2.default.createElement(SalesOffices_1.SalesOffices, null)));
        default:
            return (react_2.default.createElement(react_1.Box, { display: "flex", className: "col-md-" + columnData.grid_pc + " col-" + columnData.grid_sp + " " + (columnData.class || ""), css: columnData.style }, children));
    }
};
exports.Colmn = Colmn;
